import { Colors } from '@oy/uicore';
import { Button, Spacer, Text } from '@oy/uidesktop';
import React from 'react';
import { useTranslate } from 'src/hooks';
import styles from './EmptyState.module.css';

type EmptyStateProps = React.HTMLProps<HTMLDivElement> & {
  buttonId?: string;
  buttonName?: string;
  detail?: React.ReactNode;
  title?: string;
  actionButton?: () => void;
};

/**
 * @deprecated
 */
export default function EmptyState({
  buttonId,
  buttonName,
  detail,
  title,
  actionButton,
}: EmptyStateProps) {
  const { getTranslation } = useTranslate();
  return (
    <div className={styles.container}>
      <div>
        <Text textStyle={Text.Style.HeadingLg}>
          {title ? title : getTranslation('common_info_noTransactionFound')}
        </Text>
        <Text textStyle={Text.Style.BodyLgRegular} color={Colors.BLACK40}>
          {detail
            ? detail
            : getTranslation('common_adjustFilterOrNewTransaction')}
        </Text>
        {buttonName && (
          <Spacer top={Spacer.Size.XXL} bottom={Spacer.Size.XXXL}>
            <Button id={buttonId} onClick={actionButton}>
              {buttonName}
            </Button>
          </Spacer>
        )}
      </div>
    </div>
  );
}
